module.exports = __webpack_public_path__ + "4f04a816f50c1b2bb72c74dbcdeb0c4e.svg";